import { sessionManager, Logger } from 'vue-infra';
import { appName } from '@/common/consts';
import { initialize } from 'launchdarkly-js-client-sdk';

const logger = Logger.getLogger(`${appName}:LaunchDarklyService`);

class LaunchDarklyService {
  static client;
  static flags;

  async initClient(key) {
    logger.debug('Trying to initialize LaunchDarkly client');
    const accountId = sessionManager.getAccountId();
    const userId = sessionManager.getUserId();

    const context = {
      kind: 'user',
      key: userId,
      accountId,
    };
    this.client = await initialize(key.clientSideId, context);
    await this.client.waitForInitialization();
    this.flags = await this.client.allFlags();
  }

  getLDFeatureFlag(key) {
    return this.flags[key];
  }
}

const launchDarklyService = new LaunchDarklyService();

export default launchDarklyService;

